import type { TFunction } from "i18next";
import { formatDuration } from "../../utils";
import type { Noticed } from "./processNoticed";

export const noticedText = (
  finding: Noticed,
  nameById: Map<string, string>,
  t: TFunction,
): { headline: string; detail: string } => {
  const step = (id: string) => nameById.get(id) ?? id;
  const pct = (share: number) => Math.round(share * 100);
  switch (finding.kind) {
    case "waits":
      return {
        headline: t("processPanel.noticed_waits", { share: pct(finding.share) }),
        detail: t("processPanel.noticed_waits_detail", {
          work: formatDuration(finding.workSeconds),
          elapsed: formatDuration(finding.elapsedSeconds),
        }),
      };
    case "handoffs":
      return {
        headline: t("processPanel.noticed_handoffs", {
          share: pct(finding.share),
          from: finding.apps[0],
          to: finding.apps[1],
        }),
        detail: t("processPanel.noticed_handoffs_detail", {
          cases: finding.cases,
          total: finding.total,
          switches: finding.switches,
        }),
      };
    case "time-sink":
      return {
        headline: t("processPanel.noticed_timeSink", { step: step(finding.stepId) }),
        detail: t("processPanel.noticed_timeSink_detail", { share: pct(finding.share) }),
      };
    case "branching":
      return {
        headline: t("processPanel.noticed_branching", {
          step: step(finding.stepId),
          count: finding.nextSteps,
        }),
        detail: t("processPanel.noticed_branching_detail"),
      };
    case "rework":
      return {
        headline: t("processPanel.noticed_rework", { share: pct(finding.share) }),
        detail: t("processPanel.noticed_rework_detail", { step: step(finding.stepId) }),
      };
    case "spread":
      return {
        headline: t("processPanel.noticed_spread"),
        detail: t("processPanel.noticed_spread_detail", {
          max: formatDuration(finding.maxSeconds),
          median: formatDuration(finding.medianSeconds),
          ratio: Math.round(finding.maxSeconds / finding.medianSeconds),
        }),
      };
    case "dominant-path":
      return {
        headline: t("processPanel.noticed_dominantPath", { share: pct(finding.share) }),
        detail: t("processPanel.noticed_dominantPath_detail", { count: finding.otherPaths }),
      };
    case "no-dominant-path":
      return {
        headline: t("processPanel.noticed_noDominantPath"),
        detail: t("processPanel.noticed_noDominantPath_detail", { share: pct(finding.share) }),
      };
  }
};
